/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Erfahrungsstufeag21Inputs */



/**

* @param {_Field_Erfahrungsstufeag21Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_erfahrungsstufeag21 = /** @type {((inputs?: _Field_Erfahrungsstufeag21Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Erfahrungsstufeag21Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Erfahrungsstufe AG 2")
});
export { _field_erfahrungsstufeag21 as "_field_erfahrungsstufeAg2" }